import ProductLocationsApiV2 from 'api/v2/admins/product-locations-api-v2'
import TitlePage from 'components/atoms/title-page'
import { ALERT_TYPES } from 'constants/alert-constants'
import { LOCATION_TYPE_VALUES } from 'domains/bnk-warehouse-location/constants/location-type-labels'
import BnkWarehouseLocationCreateForm from 'domains/bnk-warehouse-location/organisms/create-form'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Card } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const BnkWarehouseLocationCreatePage = ({ pageUtils }) => {
  const [ productLocation, setProductLocation ] = useState({})

  /**
   * Handle submit to `BnkWarehouseLocationCreateForm`
   * @param {object} values final values when submitting the form.
   * @param {object} formikBag formik object
   */
  const handleSubmit = async (values, formikBag) => {
    await ProductLocationsApiV2.create({
      name      : values.name,
      type_name : values.type_name,
      active    : values.active
    })
      .then((response) => {
        const location = response.data.product_location

        setProductLocation(location)
        pageUtils.setAlertMsg(`Location ${location.name} has been created.`, ALERT_TYPES.SUCCESS)
        formikBag.resetForm()
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response?.data || error.message)
        formikBag.setErrors(error.response?.data?.messages || {})
      })
  }

  return (
    <>
      <TitlePage mainTitle={ 'Location Master' } subTitle={ 'Create' } />

      <Card body>
        <BnkWarehouseLocationCreateForm
          handleSubmit={ handleSubmit }
          productLocation={ productLocation }
          initialValues={{
            name      : '',
            type_name : LOCATION_TYPE_VALUES.ITEM,
            active    : true
          }}
          submitLabel='Create Location'
        />
      </Card>
    </>
  )
}

BnkWarehouseLocationCreatePage.propTypes = propTypes

export default BnkWarehouseLocationCreatePage